module.exports = __webpack_public_path__ + "static/media/man_han_tra.6b115ac5.png";